import { onUnmounted, ref } from 'vue'
import { COMMISSIONING_POLLING } from '~/constants/commissioningPolling'

export type CommissioningPollingPhase = 'ANALYZING' | 'ALMOST' | 'EXTENDED'

const EXTENDED_THRESHOLD_MS
  = COMMISSIONING_POLLING.ANALYZING_SCREEN_MS + COMMISSIONING_POLLING.ALMOST_SCREEN_MS

function phaseFromElapsedMs(elapsedMs: number): CommissioningPollingPhase {
  if (elapsedMs < COMMISSIONING_POLLING.ANALYZING_SCREEN_MS)
    return 'ANALYZING'

  if (elapsedMs < EXTENDED_THRESHOLD_MS)
    return 'ALMOST'

  return 'EXTENDED'
}

export default function useCommissioningPollingTimer() {
  const phase = ref<CommissioningPollingPhase>('ANALYZING')
  let intervalId: ReturnType<typeof setInterval> | null = null
  let startedAtMs: number | null = null

  function tick() {
    if (startedAtMs === null)
      return

    phase.value = phaseFromElapsedMs(Date.now() - startedAtMs)
  }

  function start() {
    stop()
    startedAtMs = Date.now()
    phase.value = 'ANALYZING'
    intervalId = setInterval(tick, 1_000)
  }

  function stop() {
    if (intervalId !== null) {
      clearInterval(intervalId)
      intervalId = null
    }
    startedAtMs = null
  }

  function reset() {
    stop()
    phase.value = 'ANALYZING'
  }

  onUnmounted(stop)

  return {
    phase,
    start,
    stop,
    reset,
  }
}
